import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PedidosDeCamionesBruto from '../../ReporteCamiones/components/pedidosDeCamionesBruto/PedidosDeCamionesBruto'
import { obtenerPedidosDeBruto } from '../../Pesado/actions'
import { getCamionesListosParaBruto } from '../../Camiones/actions'

function PedidosDeBrutoACalado (props) {
  const { camionesPedidos, obtenerPedidosDeBruto, getCamionesListosParaBruto } = props

  useEffect(() => {
    obtenerPedidosDeBruto()
    getCamionesListosParaBruto()
  }, [obtenerPedidosDeBruto])

  return (
    <>
      { camionesPedidos && <PedidosDeCamionesBruto /> }
    </>
  )
}

const mapStateToProps = (state) => ({
  camionesPedidos: state.pesado.camionesPedidosBruto
})

const mapActionsToProps = {
  obtenerPedidosDeBruto,
  getCamionesListosParaBruto
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(PedidosDeBrutoACalado)
